import {axiosUtil} from "../../../utils/axios_util";
const CallManage = {
   //列表分页查询
   getCallPage(data: any) {
    return axiosUtil({
      url: '/ai/task/list',
      method: 'post',
      data,
      params: {
        page: data.page,
        size: data.size,
      },
    })
  },
  //查询任务明细
  getTaskDetails(data: any) {
    return axiosUtil({
      url: '/ai/task/details',
      method: 'post',
      data,
      params: {
        page: data.page,
        size: data.size,
      },
    })
  },
  
  //任务明细
  setTaskDetails(data: any) {
    return axiosUtil({
      url: '/ai/task/details',
      method: 'post',
      data,
    })
  },
  
  //任务状态
  setTaskStatus(data: any) {
    return axiosUtil({
      url: '/ai/task/setTaskStatus',
      method: 'post',
      data,
    })
  },

  //新增
  addCreateTask(data:any) {
    return axiosUtil({
        url: `/ai/task/createTask`,
        method: 'post',
        data,
    })
  },
  //编辑
  editUpdateTask(data:any) {
    return axiosUtil({
        url: `/ai/task/updateTask`,
        method: 'post',
        data,
    })
  },
  
  //获取号码池及号码
  getNumberPool() {
    return axiosUtil({
        url: `/ai/task/getNumberPool`,
        method: 'post',
    })
  },
  //添加号码
  batchAppendPhone(data:any) {
    return axiosUtil({
        url: `/ai/task/batchAppendPhone`,
        method: 'post',
        data,
    })
  },
  //检查号码列表
  checkPhoneLis(data:any) {
    return axiosUtil({
        url: `/ai/task/checkPhone`,
        method: 'post',
        data,
    })
  },
  //根据id查询任务
  taskInfo(taskId: string) {
    return axiosUtil({
        url: `/ai/task/info/${taskId}`,
        method: 'get',
    })
},
  

// 添加号码接口
//根据临时id查询号码列表
getPhonePageListByWhere(data:any) {
  return axiosUtil({
      url: `/ai/task/getPhonePageListByWhere`,
      method: 'post',
      data,
      params: {
        page: data.page,
        size: data.size,
      },
  })
},
//删除临时id查询号码列表
deletePhone(data:any) {
  return axiosUtil({
      url: `/ai/task/removePhoneByWhere`,
      method: 'post',
      data,
  })
},
//添加手机号码
addPhone(data:any) {
  return axiosUtil({
      url: `/ai/task/addPhone`,
      method: 'post',
      data,
  })
},
//查询添加手机号码数量
getPhoneCount(data:any) {
  return axiosUtil({
      url: `/ai/task/getPhoneCount/`+ data.temporaryId,
      method: 'post',
  })
},
  //确认号码
  confirmPhone(data:any) {
    return axiosUtil({
        url: `/ai/task/isOkPhone/`+ data.temporaryId,
        method: 'post',
        data,
    })
  },
}

export default CallManage